<script>
    import { onDestroy, onMount } from "svelte";
    import { PRConnect } from "@projectroom/ui-lib";
    import { fade } from "svelte/transition";
    import { navigateTo } from "svelte-router-spa";
    import axios from "axios";
    import { planStore } from "./store/plan-store";
    import { _, getLocaleFromNavigator } from "svelte-i18n";
    import Cookies from "js-cookie";
    import ImagePicker from "./chat-builder/ImagePicker.svelte";
    import StatisticsDashboard from "./insights/StatisticsDashboard.svelte";
    import CollectionDashboard from "./insights/CollectionDashboard.svelte";
    import { Dialog, Button } from "../lib/ui";
    import { t } from "../common/t";

    let botList = [];
    let chatList = [];
    let isLoaded = false;
    let isAddPopup = false;
    let isModifyPopup = false;
    let isMenuPanel = false;
    let isDeletePopup = false;
    let limitNoticePopup = false;
    let isChoiceTypePage = false;
    let isChatTypeSelectPage = false;
    let flagGoBuilder = true;
    let targetBotId;
    let availableCreateCnt = 1;
    let descriptionViewCnt = 7;
    let imageLoadingPopupFlag = false;
    let planSubsc;
    let authType;
    let templateType = "EMPTY";
    let isSelectPage = false;
    let isTemplatePage = false;
    let isPreviewPage = false;
    let isNewProfilePage = false;
    let isProfileTypeSelectPage = false;
    let isGameTypeSelectPage = false;
    let profileType = '2D';
    let brandScrollEl;
    let selectedPreviewUrl = "";
    let profileReturnToPreview = false;
    let activeTemplateTab = "character";
    let newProfileFileInput;
    let templateList = [];

    // 통계/수집 섹션 프로젝트 선택기 상태.
    // statBotId = 통계 대상 봇 id / collectTarget = "bot:{id}" | "chat:{id}" (수집 대상)
    let statBotId = "";
    let collectTarget = "";

    // 목록 탐색(검색어 + 정렬). botList/chatList가 이미 전량 클라이언트에 있어 서버 왕복 없이 처리한다.
    // 기본값 recent 는 서버 ORDER BY(COALESCE(LAST_UPDATE_DATE, CREATION_DATE) DESC)와 같은 규약.
    let listQuery = "";
    let listSort = "recent"; // recent | created | name
    const listSortOptions = [
        { value: "recent", label: "최근 수정순" },
        { value: "created", label: "최근 생성순" },
        { value: "name", label: "이름순" },
    ];

    // 좌측 사이드바 섹션. profile/character 는 같은 미니페이지(botList)를 PAGE_TYPE 으로 나눈 것.
    let activeSection = "profile"; // profile | character | chat | game | asset
    const sectionIcons = {
        profile:
            '<rect width="18" height="18" x="3" y="3" rx="2"/><circle cx="9" cy="10" r="2"/><path d="M15 8h2"/><path d="M15 12h2"/><path d="M7 16h10"/>',
        character:
            '<circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" x2="9.01" y1="9" y2="9"/><line x1="15" x2="15.01" y1="9" y2="9"/>',
        hub: '<rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/>',
        chat: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
        statistics: '<line x1="12" x2="12" y1="20" y2="10"/><line x1="18" x2="18" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="16"/>',
        collection: '<path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>',
        game: '<line x1="6" x2="10" y1="12" y2="12"/><line x1="8" x2="8" y1="10" y2="14"/><line x1="15" x2="15.01" y1="13" y2="13"/><line x1="18" x2="18.01" y1="11" y2="11"/><rect width="20" height="12" x="2" y="6" rx="2"/>',
        asset: '<rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>',
        launcher: '<path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91 0z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>',
    };
    const sections = [
        { value: "profile", label: "프로필페이지", desc: "링크·프로필 중심의 미니페이지" },
        { value: "character", label: "캐릭터페이지", desc: "캐릭터형 아바톡 미니페이지" },
        { value: "hub", label: "허브페이지", desc: "채팅을 격자로 모아 보여주는 진입 페이지" },
        { value: "chat", label: "챗", desc: "생성형 AI 챗봇" },
        { value: "statistics", label: "통계", desc: "미니페이지 방문·클릭 분석" },
        { value: "collection", label: "수집", desc: "폼 응답·답변·개인정보 모아보기" },
        { value: "game", label: "게임페이지", desc: "플레이할 수 있는 게임형 페이지" },
        { value: "launcher", label: "런처페이지", desc: "운세·게임·채팅을 한 홈으로 모으는 입구 페이지" },
        { value: "asset", label: "이미지에셋", desc: "계정 전체 이미지 라이브러리" },
    ];

    // PAGE_TYPE 이 ENTERPRISE 면 프로필페이지, 그 외(2D/미지정)는 캐릭터페이지.
    const pageTypeOf = (b) => String(b.pageType || "").toUpperCase();
    $: profileBots = botList.filter((b) => pageTypeOf(b) === "ENTERPRISE");
    $: hubBots = botList.filter((b) => pageTypeOf(b) === "HUB");
    $: gameBots = botList.filter((b) => pageTypeOf(b) === "GAME");
    $: launcherBots = botList.filter((b) => pageTypeOf(b) === "LAUNCHER");
    // ⚠️ 캐릭터페이지는 '나머지 전부'가 아니다. 예전엔 !== 'ENTERPRISE' 였는데 그러면
    //    허브(HUB)까지 캐릭터 목록으로 빨려 들어간다 → 아는 타입을 빼는 방식으로 바꾼다.
    //    ⭐ 새 페이지 타입을 만들 때마다 여기 한 줄을 같이 고쳐야 한다(안 그러면 캐릭터 목록에 섞인다).
    $: characterBots = botList.filter(
        (b) => !["ENTERPRISE", "HUB", "GAME", "LAUNCHER"].includes(pageTypeOf(b)),
    );
    $: currentBots =
        activeSection === "profile" ? profileBots
        : activeSection === "hub" ? hubBots
        : activeSection === "game" ? gameBots
        : activeSection === "launcher" ? launcherBots
        : characterBots;

    // 섹션을 옮기면 검색어는 리셋한다(다른 목록에 남은 필터가 "비어 보이는" 착시를 만든다).
    $: if (activeSection) listQuery = "";

    // 편집 화면은 페이지 타입마다 다르다. 게임은 에셋 슬롯·편대 저작이라 봇 빌더와 화면이 아예 다르고
    // 전용 라우트(/game-builder)를 쓴다 — 여기서 갈라주지 않으면 게임을 열 때 빈 봇 빌더가 뜬다.
    const builderPathOf = (bot) => {
        const t = pageTypeOf(bot);
        if (t === "GAME") return `/game-builder/${bot.id}`;
        if (t === "LAUNCHER") return `/launcher-builder/${bot.id}`;
        return `/builder/${bot.id}`;
    };

    const ts = (v) => (v ? new Date(v).getTime() : 0);
    // 서버 COALESCE와 동일: 수정일이 없으면 생성일을 최근 활동으로 본다.
    const recencyTs = (it) => ts(it.lastUpdateDate) || ts(it.creationDate);

    // 제목·부제 부분 일치로 거른 뒤 정렬. filter/slice 로 원본 배열은 건드리지 않는다.
    const applyListView = (list, query, sort) => {
        const q = query.trim().toLowerCase();
        const rows = q
            ? list.filter((it) =>
                  `${it.title || ""} ${it.subTitle || ""}`
                      .toLowerCase()
                      .includes(q),
              )
            : list.slice();
        if (sort === "name") {
            // 제목 없는 항목은 맨 뒤로(빈 카드가 목록 머리에 오는 걸 막는다).
            return rows.sort((a, b) => {
                const at = (a.title || "").trim();
                const bt = (b.title || "").trim();
                if (!at !== !bt) return at ? -1 : 1;
                return at.localeCompare(bt, "ko");
            });
        }
        if (sort === "created") {
            return rows.sort((a, b) => ts(b.creationDate) - ts(a.creationDate));
        }
        return rows.sort((a, b) => recencyTs(b) - recencyTs(a));
    };

    $: visibleBots = applyListView(currentBots, listQuery, listSort);
    $: visibleChats = applyListView(chatList, listQuery, listSort);
    $: visibleList = activeSection === "chat" ? visibleChats : visibleBots;
    $: isSearching = listQuery.trim().length > 0;
    // 카드 그리드를 쓰는 섹션에서만 툴바를 띄운다(통계/수집/에셋 제외).
    $: isListSection = ["profile", "character", "hub", "chat", "game", "launcher"].includes(
        activeSection,
    );
    $: sectionCounts = {
        profile: profileBots.length,
        character: characterBots.length,
        hub: hubBots.length,
        chat: chatList.length,
        game: gameBots.length,
        launcher: launcherBots.length,
        statistics: botList.length,
        collection: botList.length + chatList.length,
    };
    $: currentSection = sections.find((s) => s.value === activeSection) || {};

    // 섹션 진입 시 선택기 기본값(첫 프로젝트). 이미 고른 값이 있으면 유지.
    $: if (activeSection === "statistics" && !statBotId && botList.length) {
        statBotId = botList[0].id;
    }
    $: if (activeSection === "collection" && !collectTarget) {
        if (botList.length) collectTarget = `bot:${botList[0].id}`;
        else if (chatList.length) collectTarget = `chat:${chatList[0].id}`;
    }
    // collectTarget 파싱: 종류(bot|chat) + id
    $: collectKind = collectTarget.startsWith("chat:") ? "chat" : "bot";
    $: collectId = collectTarget.split(":")[1] || "";
    $: anyOverlay =
        isChoiceTypePage ||
        isChatTypeSelectPage ||
        isProfileTypeSelectPage ||
        isGameTypeSelectPage ||
        isSelectPage ||
        isTemplatePage ||
        isPreviewPage ||
        isNewProfilePage;
    let locale =
        Cookies.get("lang") || getLocaleFromNavigator().substring(0, 2);
    const origin =
        typeof window !== "undefined" ? window.location.origin : "";

    const TYPE_BUILDER = "BUILDER";
    const TYPE_CREATE = "CREATE";

    let botInfo = {
        title: "",
        subTitle: "",
        iconImageContent: "",
        customUrl: "https://www.avatalk.com/v?",
    };
    let modifyBotInfo = {
        title: "",
        subTitle: "",
        iconImageContent: "",
        customUrl: "https://www.avatalk.com/v?",
    };
    let addFileInput, editFileInput;

    onMount(() => {
        getBotList();
        getChatList();
        getTemplateList();
        planStore.init();
        planSubsc = planStore.subscribe((message) => {
            authType = message?.authType;
            availableCreateCnt = message?.botCnt;
        });
    });

    onDestroy(() => {
        planSubsc();
    });

    const isAvailableCreate = () => {
        return botList.length + chatList.length <= availableCreateCnt;
    };

    const getBotList = () => {
        PRConnect.send("/api/Bot/getBotListById", {}, (data) => {
            if (data.header.status === "success") {
                botList = data.result;
                isLoaded = true;
                descriptionViewCnt -= botList.length;
                if (descriptionViewCnt < 0) {
                    descriptionViewCnt = 0;
                }
                // availableCreateCnt = data.result[0].limitNum;
            }
        });
    };

    const getTemplateList = () => {
        PRConnect.send(
            "/api/Bot/getTemplateList",
            { lang: locale.toUpperCase() },
            (data) => {
                if (data.header.status === "success") {
                    templateList = data.result;
                }
            },
        );
    };

    const getChatList = () => {
        PRConnect.send("/api/Chat/getChatList", {}, (data) => {
            if (data.header.status === "success") {
                chatList = data.result;
                descriptionViewCnt -= botList.length;
                if (descriptionViewCnt < 0) {
                    descriptionViewCnt = 0;
                }
            }
        });
    };

    const addBotProfile = () => {
        isAddPopup = false;
        clickBotCreateTemplate(TYPE_CREATE);
    };

    const initModifyBotProfile = (bot) => {
        isModifyPopup = true;
        modifyBotInfo = { ...bot };
    };

    // 섹션별 생성 진입. profile/character 는 타입만 다르고 제작 흐름은 동일(미니페이지).
    const startCreate = () => {
        if (!isAvailableCreate()) {
            limitNoticePopup = true;
            return;
        }
        if (activeSection === "chat") {
            isChatTypeSelectPage = true;
            return;
        }
        if (activeSection === "game") {
            // 게임은 타입마다 규칙도 에셋도 달라서 먼저 무엇을 만들지 고른다.
            isGameTypeSelectPage = true;
            return;
        }
        if (activeSection === "launcher") {
            // 런처도 허브처럼 고를 타입이 없다 — 확장축이 '타일' 하나라(설계 §2-1)
            // 만들 때 정할 게 없다. 바로 만들고 저작 화면으로 보낸다.
            PRConnect.send(
                "/api/Bot/createLauncherBot",
                { title: "새 런처페이지", subTitle: "" },
                (data) => {
                    if (data.header.status === "success") {
                        navigateTo(`/launcher-builder/${data.result}`);
                    }
                },
            );
            return;
        }
        if (activeSection === "hub") {
            // 허브는 고를 템플릿이 없다(시나리오·버튼이 없는 타입) → 바로 만들고 저작 화면으로.
            PRConnect.send(
                "/api/Bot/createHubBot",
                { title: "새 허브페이지", subTitle: "" },
                (data) => {
                    if (data.header.status === "success") {
                        navigateTo(`/builder/${data.result}`);
                    }
                },
            );
            return;
        }
        profileType = activeSection === "profile" ? "ENTERPRISE" : "2D";
        isSelectPage = true;
    };

    const modifyBotProfile = (e) => {
        PRConnect.send("/api/Bot/modifyBot", modifyBotInfo, (data) => {
            if (data.header.status === "success") {
                isModifyPopup = false;
                modifyBotInfo = {};
                getBotList();
            }
        });
    };

    // const onImageFileSelected = (e) => {
    //     let image = e.target.files[0];
    //     let reader = new FileReader();
    //     reader.readAsDataURL(image);
    //     const type = e.target.name;
    //     reader.onload = (e) => {
    //         if (type === "add") {
    //             botInfo.iconImageContent = e.target.result;
    //         } else {
    //             modifyBotInfo.iconImageContent = e.target.result;
    //         }
    //     }
    // }

    const clickBotCreate = () => {
        if (!isAvailableCreate()) {
            limitNoticePopup = true;
            return;
        }
        isChoiceTypePage = true;
    };

    const clickGoBuilder = (editFlag) => {
        if (editFlag) {
            modifyBotProfile();
            navigateTo(`/builder/${modifyBotInfo.id}`);
            return;
        }
        flagGoBuilder = false;

        clickBotCreateTemplate(TYPE_BUILDER);
    };

    const clickImageDelete = () => {
        modifyBotInfo.iconImageContent = undefined;
    };

    const clickBotDelete = (botId) => {
        isDeletePopup = true;
        targetBotId = botId;
    };

    const actionBotDelete = () => {
        PRConnect.send("/api/Bot/deleteBot", { botId: targetBotId }, (data) => {
            if (data.header.status === "success") {
                getBotList();
                isDeletePopup = false;
            }
        });
    };

    const clickBotCopy = (botId) => {
        if (!isAvailableCreate()) {
            limitNoticePopup = true;
            return;
        }
        imageLoadingPopupFlag = true;
        PRConnect.send("/api/Bot/copyBot", { botId }, (data) => {
            if (data.header.status === "success") {
                imageLoadingPopupFlag = false;
                getBotList();
            }
        });
    };

    const clickBotCreateTemplate = (type) => {
        // 기업형 + 빈 페이지(EMPTY) → 프로그램적 빈 봇 생성.
        // 기업형 + 템플릿(BRAND_*) 또는 캐릭터형 전부 → 템플릿 row 복사(copyBot).
        if (profileType === "ENTERPRISE" && templateType === "EMPTY") {
            PRConnect.send(
                "/api/Bot/createEnterpriseBot",
                { ...botInfo },
                (data) => {
                    if (data.header.status === "success") {
                        if (type == TYPE_CREATE) {
                            getBotList();
                        } else if (type == TYPE_BUILDER) {
                            navigateTo(`/builder/${data.result}`);
                        }
                    }
                },
            );
            return;
        }
        const langTemplateType = `${templateType}_${locale.toUpperCase()}`;
        PRConnect.send(
            "/api/Bot/copyBot",
            { ...botInfo, templateType: langTemplateType, pageType: profileType },
            (data) => {
                if (data.header.status === "success") {
                    if (type == TYPE_CREATE) {
                        getBotList();
                    } else if (type == TYPE_BUILDER) {
                        navigateTo(`/builder/${data.result}`);
                    }
                }
            },
        );
    };

    const onImageFileSelected = (e) => {
        let index = e.target._index_;
        let image = e.target.files[0];
        const key = `common/temp/${image.name}`;
        const type = image.type;
        const actionType = e.target.name;
        PRConnect.send(
            "/api/File/uploadPresignedUrl",
            { key, type },
            (data) => {
                axios
                    .put(data.result, image, {
                        headers: { "Content-Type": type },
                    })
                    .then((response) => {
                        if (actionType === "add") {
                            botInfo.iconImageContent = `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/temp/${image.name}`;
                        } else {
                            modifyBotInfo.iconImageContent = `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/temp/${image.name}`;
                        }
                    });
            },
        );
    };

    const clickChangePlan = () => {
        planStore.setAuthSelectFlag(true);
        limitNoticePopup = false;
    };

    const clickPreviewTemplate = (e) => {
        const card = e.target.closest(".template-card-item");
        if (!card) return;
        templateType = card.dataset.templateType;
        selectedPreviewUrl = card.dataset.previewUrl || "";
        isTemplatePage = false;
        isPreviewPage = true;
    };

    const previewTemplate = (type, code) => {
        templateType = type;
        selectedPreviewUrl = `${origin}/view/${code}`;
        isTemplatePage = false;
        isPreviewPage = true;
    };

    const useTemplateDirectly = (type) => {
        templateType = type;
        isTemplatePage = false;
        isPreviewPage = false;
        profileReturnToPreview = false;
        botInfo = {
            title: "",
            subTitle: "",
            iconImageContent: "",
            customUrl: "https://avatalk.in/v?",
        };
        isNewProfilePage = true;
    };

    const scrollBrand = (dir) => {
        brandScrollEl?.scrollBy({ left: dir * 330, behavior: "smooth" });
    };

    const handleUseTemplate = () => {
        isPreviewPage = false;
        profileReturnToPreview = true;
        botInfo = {
            title: "",
            subTitle: "",
            iconImageContent: "",
            customUrl: "https://avatalk.in/v?",
        };
        isNewProfilePage = true;
    };

    const addBotProfileFromPage = () => {
        isNewProfilePage = false;
        clickBotCreateTemplate(TYPE_CREATE);
    };

    const clickGoBuilderFromPage = () => {
        flagGoBuilder = false;
        isNewProfilePage = false;
        clickBotCreateTemplate(TYPE_BUILDER);
    };

    const clickChatTypeSelect = () => {
        isChoiceTypePage = false;
        isChatTypeSelectPage = true;
    };

    // 고를 수 있는 게임 타입. ⚠️ value 는 서버 Bot.js GAME_TYPES 및 런타임 registry.ts 의 키와 같아야 한다.
    //    ready:false 면 카드는 보이되 못 고른다 — 무엇이 올지 알리되 만들어지진 않게.
    const gameTypes = [
        {
            value: "VERTICAL_SHOOTER",
            name: "세로 슈팅",
            desc: "위에서 내려오는 적을 쏘며 버티는<br />세로 스크롤 슈팅 게임",
            ready: true,
        },
        {
            value: "MATCH3",
            name: "매치 퍼즐",
            desc: "같은 블록 3개를 맞춰 없애는<br />3매치 퍼즐 게임",
            ready: false,
        },
    ];

    const clickGameCreate = (gameType) => {
        isGameTypeSelectPage = false;
        imageLoadingPopupFlag = true;
        PRConnect.send("/api/Bot/createGameBot", { title: "새 게임페이지", subTitle: "", gameType }, (data) => {
            imageLoadingPopupFlag = false;
            if (data.header.status === "success") {
                navigateTo(`/game-builder/${data.result}`);
            }
        });
    };

    const clickChatCreate = (chatType) => {
        PRConnect.send("/api/Chat/createChat", { chatType }, (data) => {
            if (data.header.status === "success") {
                navigateTo(`/chat-builder/${data.result}`);
            }
        });
    };

    // 에셋(current 버전 URL) 우선 → 레거시 파일명 경로 → 둘 다 없으면 null(빈 아바타).
    // ChatBuilder의 getProfileImageContent()와 동일 규약. 에셋으로 바꾼 챗은 PROFILE_IMAGE_CONTENT가 비어 있다.
    const getChatProfileImageContent = (chat) => {
        if (chat.profileAssetId) return chat.profileAssetUrl || null;
        if (!chat.profileImageContent) return null;
        return `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/chats/${chat.id}/common/profile-images/${chat.profileImageContent}`;
    };
</script>

{#if isLoaded}
    <div
        class="container home"
        in:fade
        on:click={() => {
            botList = botList.map((bot) => ({
                ...bot,
                isMenuPanel: false,
                isModifyPopup: false,
                isAddPopup: false,
            }));
        }}
    >
        <div class="avatalk-version-choice" class:show={isChoiceTypePage}>
            <div class="version-choice-copy">
                <div
                    class="blank-page-avatalk _2 pointer"
                    on:click={() => {
                        isChoiceTypePage = false;
                        isProfileTypeSelectPage = true;
                    }}
                >
                    <img
                        src="/static/images/ava-profileLink.png"
                        loading="lazy"
                        alt=""
                        class="image-165"
                    />
                    <div class="text-block-96-2">
                        <span class="text-span-60">미니페이지</span> 제작
                    </div>
                    <div class="text-block-97-2">
                        <strong>소개, 콘텐츠, 채널 등</strong>을 한 곳에 담은<br
                        />
                        미니 페이지를 손쉽게 만들어보세요.
                    </div>
                </div>
                <div class="div-block-77"></div>
                <div
                    class="template-page-avatalk _2 pointer"
                    on:click={clickChatTypeSelect}
                >
                    <img
                        src="/static/images/Character-chat.png"
                        loading="lazy"
                        alt=""
                        class="image-165"
                    />
                    <div class="text-block-96-2">
                        <span class="text-span-62">AI 챗봇</span> 제작
                    </div>
                    <div class="text-block-97-2">
                        <strong>생성형 AI</strong>를 활용해 고객, 방문자, 팬
                        등과 <br />
                        소통하는 챗봇을 손쉽게 만들어보세요.
                    </div>
                </div>
            </div>
            <div
                class="x-button cursor"
                on:click={() => (isChoiceTypePage = false)}
            ></div>
        </div>
        <!-- AI챗 타입 선택 페이지 -->
        <div
            class="avatalk-version-choice select-page"
            class:show={isChatTypeSelectPage}
        >
            <div class="version-choice-copy">
                <div
                    class="blank-page-avatalk _2 pointer"
                    on:click={() => {
                        isChatTypeSelectPage = false;
                        clickChatCreate("CHARACTER");
                    }}
                >
                    <img
                        src="/static/images/chat-type-character.png"
                        loading="lazy"
                        alt=""
                        class="image-165"
                    />
                    <div class="text-block-96-2">
                        <span class="text-span-60">캐릭터용</span> AI챗
                    </div>
                    <div class="text-block-97-2">
                        <strong>캐릭터 페르소나</strong>를 적용하여 다양한<br />
                        AI 캐릭터 콘텐츠를 생성해보세요!
                    </div>
                </div>
                <div class="div-block-77"></div>
                <div
                    class="template-page-avatalk _2 pointer"
                    on:click={() => {
                        isChatTypeSelectPage = false;
                        clickChatCreate("ENTERPRISE");
                    }}
                >
                    <img
                        src="/static/images/chat-type-enterprise.png"
                        loading="lazy"
                        alt=""
                        class="image-165"
                    />
                    <div class="text-block-96-2">
                        <span class="text-span-62">브랜드/기업용</span> AI챗
                    </div>
                    <div class="text-block-97-2">
                        <strong>브랜드 소개부터 문의 응대까지,</strong><br />
                        고객과 소통하는 AI챗을 손쉽게 제작해보세요!
                    </div>
                </div>
            </div>
            <div
                class="x-button cursor"
                on:click={() => {
                    isChatTypeSelectPage = false;
                    isChoiceTypePage = true;
                }}
            ></div>
        </div>

        <!-- 게임 타입 선택 페이지.
             ⚠️ 다른 오버레이와 달리 일러스트 대신 인라인 SVG를 쓴다 — 게임용 이미지 자산이 아직 없고,
                없는 경로를 참조하면 깨진 이미지가 뜬다. 자산이 생기면 <img>로 바꾸면 된다. -->
        <div
            class="avatalk-version-choice select-page"
            class:show={isGameTypeSelectPage}
        >
            <div class="version-choice-copy">
                {#each gameTypes as g, i (g.value)}
                    {#if i > 0}
                        <div class="div-block-77"></div>
                    {/if}
                    <div
                        class="blank-page-avatalk _2 game-type-card"
                        class:pointer={g.ready}
                        class:is-soon={!g.ready}
                        on:click={() => g.ready && clickGameCreate(g.value)}
                    >
                        <div class="game-type-art game-type-art-{g.value}">
                            {#if g.value === "VERTICAL_SHOOTER"}
                                <svg viewBox="0 0 120 120" fill="none" aria-hidden="true">
                                    <rect x="14" y="16" width="20" height="14" rx="3" fill="#ff5a5a" />
                                    <rect x="50" y="16" width="20" height="14" rx="3" fill="#ffa53d" />
                                    <rect x="86" y="16" width="20" height="14" rx="3" fill="#ff5a5a" />
                                    <rect x="32" y="40" width="20" height="14" rx="3" fill="#b46bff" />
                                    <rect x="68" y="40" width="20" height="14" rx="3" fill="#ff5a5a" />
                                    <rect x="57" y="64" width="6" height="16" rx="3" fill="#ffe66d" />
                                    <path d="M60 86 L76 112 L44 112 Z" fill="#4dd2ff" />
                                </svg>
                            {:else}
                                <svg viewBox="0 0 120 120" fill="none" aria-hidden="true">
                                    <rect x="16" y="16" width="26" height="26" rx="7" fill="#5ce1a6" />
                                    <rect x="47" y="16" width="26" height="26" rx="7" fill="#ffa53d" />
                                    <rect x="78" y="16" width="26" height="26" rx="7" fill="#4dd2ff" />
                                    <rect x="16" y="47" width="26" height="26" rx="7" fill="#ffa53d" />
                                    <rect x="47" y="47" width="26" height="26" rx="7" fill="#ffa53d" />
                                    <rect x="78" y="47" width="26" height="26" rx="7" fill="#ffa53d" />
                                    <rect x="16" y="78" width="26" height="26" rx="7" fill="#b46bff" />
                                    <rect x="47" y="78" width="26" height="26" rx="7" fill="#5ce1a6" />
                                    <rect x="78" y="78" width="26" height="26" rx="7" fill="#ff5a5a" />
                                </svg>
                            {/if}
                        </div>
                        <div class="text-block-96-2">
                            <span class="text-span-60">{g.name}</span>
                            {#if !g.ready}<span class="game-type-soon">준비중</span>{/if}
                        </div>
                        <div class="text-block-97-2">{@html g.desc}</div>
                    </div>
                {/each}
            </div>
            <div
                class="x-button cursor"
                on:click={() => (isGameTypeSelectPage = false)}
            ></div>
        </div>

        <!-- 미니페이지 타입 선택 페이지 -->
        <div
            class="avatalk-version-choice select-page"
            class:show={isProfileTypeSelectPage}
        >
            <div class="version-choice-copy">
                <div
                    class="blank-page-avatalk _2 pointer"
                    on:click={() => {
                        profileType = '2D';
                        isProfileTypeSelectPage = false;
                        isSelectPage = true;
                    }}
                >
                    <img
                        src="/static/images/chat-type-character.png"
                        loading="lazy"
                        alt=""
                        class="image-165"
                    />
                    <div class="text-block-96-2">
                        <span class="text-span-60">캐릭터형</span> 미니페이지
                    </div>
                    <div class="text-block-97-2">
                        <strong>캐릭터 이미지와 대화 버튼</strong>으로 구성된<br />
                        아바톡 스타일 미니페이지를 만들어보세요.
                    </div>
                </div>
                <div class="div-block-77"></div>
                <div
                    class="template-page-avatalk _2 pointer"
                    on:click={() => {
                        profileType = 'ENTERPRISE';
                        isProfileTypeSelectPage = false;
                        isSelectPage = true;
                    }}
                >
                    <img
                        src="/static/images/chat-type-enterprise.png"
                        loading="lazy"
                        alt=""
                        class="image-165"
                    />
                    <div class="text-block-96-2">
                        <span class="text-span-62">기업형</span> 미니페이지
                    </div>
                    <div class="text-block-97-2">
                        <strong>링크 버튼과 프로필</strong> 중심의<br />
                        기업용 링크인바이오 페이지를 만들어보세요.
                    </div>
                </div>
            </div>
            <div
                class="x-button cursor"
                on:click={() => {
                    isProfileTypeSelectPage = false;
                    isChoiceTypePage = true;
                }}
            ></div>
        </div>

        <!-- 제작 방식 선택 페이지 -->
        <div
            class="avatalk-version-choice select-page"
            class:show={isSelectPage}
        >
            <div class="version-choice-copy">
                <div
                    class="blank-page-avatalk _2 pointer"
                    on:click={() => {
                        templateType = "EMPTY";
                        isSelectPage = false;
                        profileReturnToPreview = false;
                        botInfo = {
                            title: "",
                            subTitle: "",
                            iconImageContent: "",
                            customUrl: "https://avatalk.in/v?",
                        };
                        isNewProfilePage = true;
                    }}
                >
                    <img
                        src="/static/images/blank-page-illust.png"
                        loading="lazy"
                        alt=""
                        class="image-165"
                    />
                    <div class="text-block-96-2">
                        <span class="text-span-60">빈 페이지</span>로 시작하기
                    </div>
                    <div class="text-block-97-2">
                        <strong>빈 페이지</strong>에서 원하는 구성으로<br />
                        자유롭게 제작해보세요.
                    </div>
                </div>
                <div class="div-block-77"></div>
                <div
                    class="template-page-avatalk _2 pointer"
                    on:click={() => {
                        isSelectPage = false;
                        isTemplatePage = true;
                    }}
                >
                    <img
                        src="/static/images/template-page-image.png"
                        loading="lazy"
                        alt=""
                        class="image-165"
                    />
                    <div class="text-block-96-2">
                        <span class="text-span-62">템플릿</span>으로 시작하기
                    </div>
                    <div class="text-block-97-2">
                        <strong>템플릿</strong>을 활용하여<br />
                        쉽고 빠르게 제작해보세요.
                    </div>
                </div>
            </div>
            <div
                class="x-button cursor"
                on:click={() => {
                    isSelectPage = false;
                    isProfileTypeSelectPage = true;
                }}
            ></div>
        </div>

        <!-- 템플릿 선택 페이지 -->
        <div
            class="avatalk-version-choice template-select-page"
            class:show={isTemplatePage}
        >
            <div class="template-content-wrapper">
                <div class="template-type-tabs">
                    <div
                        class="template-tab-item pointer"
                        class:active={activeTemplateTab === "character"}
                        on:click={() => (activeTemplateTab = "character")}
                    >
                        캐릭터
                    </div>
                    <div
                        class="template-tab-item pointer"
                        class:active={activeTemplateTab === "brand" ||
                            activeTemplateTab === "enterprise"}
                        on:click={() => (activeTemplateTab = "brand")}
                    >
                        브랜드/기업
                    </div>
                </div>
                <div
                    class="template-cards-wrapper"
                    on:click={clickPreviewTemplate}
                >
                    {#if activeTemplateTab === "character"}
                        {#each templateList.filter((t) => t.tab === "character") as t}
                            <div
                                class="template-card-item pointer"
                                data-template-type={t.type}
                                data-preview-url="{origin}/view/{t.code}"
                            >
                                <div class="template-thumb-area">
                                    <iframe
                                        src="{origin}/view/{t.code}"
                                        class="template-thumb"
                                        scrolling="no"
                                        title={t.title}
                                    ></iframe>
                                    <div class="template-preview-overlay">
                                        미리보기
                                    </div>
                                </div>
                                <div class="template-card-title">{t.title}</div>
                            </div>
                        {/each}
                    {:else if activeTemplateTab === "brand"}
                        {#each templateList.filter((t) => t.tab === "brand") as t}
                            <div
                                class="template-card-item pointer"
                                data-template-type={t.type}
                                data-preview-url="{origin}/view/{t.code}"
                            >
                                <div class="template-thumb-area">
                                    <iframe
                                        src="{origin}/view/{t.code}"
                                        class="template-thumb"
                                        scrolling="no"
                                        title={t.title}
                                    ></iframe>
                                    <div class="template-preview-overlay">
                                        <button
                                            class="overlay-btn"
                                            on:click|stopPropagation={() =>
                                                previewTemplate(t.type, t.code)}
                                            >미리보기</button
                                        >
                                        <button
                                            class="overlay-btn overlay-btn-use"
                                            on:click|stopPropagation={() =>
                                                useTemplateDirectly(t.type)}
                                            >사용하기</button
                                        >
                                    </div>
                                </div>
                                <div class="template-card-title">{t.title}</div>
                            </div>
                        {/each}
                    {/if}
                </div>
            </div>
            <div
                class="x-button cursor"
                on:click={() => {
                    isTemplatePage = false;
                    isSelectPage = true;
                }}
            ></div>
        </div>

        <!-- 템플릿 미리보기 페이지 -->
        <div
            class="avatalk-version-choice preview-page"
            class:show={isPreviewPage}
        >
            <div class="preview-content">
                {#if selectedPreviewUrl}
                    <iframe
                        src={selectedPreviewUrl}
                        title="템플릿 미리보기"
                        class="preview-iframe"
                    ></iframe>
                {:else}
                    <div class="preview-placeholder">
                        <img
                            src="/static/images/template-page-image.png"
                            alt=""
                            class="preview-placeholder-img"
                        />
                    </div>
                {/if}
                <button
                    class="use-template-btn cursor"
                    on:click={handleUseTemplate}>사용하기</button
                >
            </div>
            <div
                class="x-button cursor"
                on:click={() => {
                    isPreviewPage = false;
                    isTemplatePage = true;
                }}
            ></div>
        </div>

        <!-- 새 프로젝트 프로필 설정 페이지 (fullscreen) -->
        <div
            class="avatalk-version-choice new-profile-page"
            class:show={isNewProfilePage}
        >
            <div class="new-profile-card">
                <div class="titile-text">
                    <div class="h1 margin20">
                        {$_("project.main.19")}<!-- 프로필 설정 -->
                    </div>
                    <div class="title-sub">
                        {$_(
                            "project.main.20",
                        )}<!-- 아바톡 목록에서 보여질 프로필을 설정해주세요! -->
                    </div>
                </div>
                <div class="frofile-setting-button">
                    {#if botInfo.iconImageContent}
                        <img
                            class="avatar-img"
                            src={botInfo.iconImageContent}
                            alt="userImage"
                        />
                    {:else}
                        <div class="frofile-image blank"></div>
                    {/if}
                    <a
                        href="#"
                        class="button w-button"
                        on:click={() => newProfileFileInput.click()}
                        >{$_("project.main.21")}<!-- 파일 업로드 --></a
                    >
                    <input
                        accept="image/png, image/jpeg, image/jpg, image/gif"
                        bind:this={newProfileFileInput}
                        type="file"
                        name="add"
                        on:change={(event) => onImageFileSelected(event)}
                        hidden
                    />
                </div>
                <div class="w-form">
                    <form class="form-2">
                        <label for="new-name" class="field-label"
                            >{$_(
                                "project.main.22",
                            )}<!-- 프로젝트 이름 --></label
                        >
                        <input
                            type="text"
                            class="avatalk-name-setting w-input"
                            bind:value={botInfo.title}
                            maxlength="30"
                            name="name"
                            id="new-name"
                        />
                        <label for="new-subtitle" class="field-label-2"
                            >{$_("project.main.24")}<!-- 프로젝트 소개 --><span
                                >{$_(
                                    "project.main.25",
                                )}<!-- (최대30자) --></span
                            ></label
                        >
                        <input
                            type="text"
                            class="avatalk-name-setting w-input"
                            bind:value={botInfo.subTitle}
                            maxlength="30"
                            name="subtitle"
                            id="new-subtitle"
                        />
                        <div class="new-profile-btn-row">
                            {#if flagGoBuilder}
                                <a
                                    href="#"
                                    class="save-button w-button"
                                    on:click={addBotProfileFromPage}
                                    >{$_("project.main.27")}<!-- 저장 --></a
                                >
                                <a
                                    href="#"
                                    class="frofile-button popup w-button"
                                    on:click={clickGoBuilderFromPage}
                                    >{$_("project.main.28")}<!-- 제작하기 --></a
                                >
                            {:else}
                                <a
                                    href="#"
                                    class="frofile-button popup w-button waiting"
                                    >{$_(
                                        "project.main.29",
                                    )}<!-- 제작중... --></a
                                >
                            {/if}
                        </div>
                    </form>
                </div>
            </div>
            <div
                class="x-button cursor"
                on:click={() => {
                    isNewProfilePage = false;
                    if (profileReturnToPreview) {
                        isPreviewPage = true;
                    } else {
                        isSelectPage = true;
                    }
                }}
            ></div>
        </div>

        <!-- 콘솔 셸: 좌측 섹션 사이드바 + 우측 콘텐츠. 생성 오버레이가 뜨면 통째로 숨김. -->
        <div class="console-shell" class:hide={anyOverlay}>
            <aside class="console-sidebar">
                <div class="console-sidebar-title">스튜디오</div>
                <nav class="console-nav">
                    {#each sections as sec (sec.value)}
                        <button
                            type="button"
                            class="console-nav-btn"
                            class:is-active={activeSection === sec.value}
                            on:click={() => (activeSection = sec.value)}
                        >
                            <svg
                                class="console-nav-icon"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                {@html sectionIcons[sec.value]}
                            </svg>
                            <span class="console-nav-label">{$t(sec.label)}</span>
                            {#if sectionCounts[sec.value]}
                                <span class="console-nav-count"
                                    >{sectionCounts[sec.value]}</span
                                >
                            {/if}
                        </button>
                    {/each}
                </nav>
            </aside>

            <main class="console-main">
                <div class="console-head">
                    <div class="console-title">{$t(currentSection.label)}</div>
                    <div class="console-desc">{$t(currentSection.desc)}</div>
                </div>

                {#if isListSection}
                    <div class="list-toolbar">
                        <div class="list-search">
                            <svg
                                class="list-search-icon"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <circle cx="11" cy="11" r="8" />
                                <path d="m21 21-4.3-4.3" />
                            </svg>
                            <input
                                class="list-search-input"
                                type="text"
                                placeholder="이름으로 검색"
                                bind:value={listQuery}
                            />
                            {#if isSearching}
                                <button
                                    type="button"
                                    class="list-search-clear"
                                    aria-label="검색어 지우기"
                                    on:click={() => (listQuery = "")}>×</button
                                >
                            {/if}
                        </div>
                        <select
                            class="insight-select list-sort"
                            aria-label="정렬 기준"
                            bind:value={listSort}
                        >
                            {#each listSortOptions as o (o.value)}
                                <option value={o.value}>{o.label}</option>
                            {/each}
                        </select>
                        <div class="list-count">
                            {visibleList.length}개{isSearching ? " 찾음" : ""}
                        </div>
                    </div>
                {/if}

                {#if activeSection === "asset"}
                    <div class="asset-embed">
                        <ImagePicker embedded />
                    </div>
                {:else if activeSection === "statistics"}
                    <div class="insight-embed">
                        {#if botList.length === 0}
                            <div class="console-empty">
                                <div class="console-empty-title">아직 미니페이지가 없어요</div>
                                <div class="console-empty-desc">
                                    프로필·캐릭터 페이지를 만들면 방문·클릭 통계를 볼 수 있어요.
                                </div>
                            </div>
                        {:else}
                            <div class="insight-bar">
                                <label class="insight-label" for="stat-pick">프로젝트</label>
                                <select id="stat-pick" class="insight-select" bind:value={statBotId}>
                                    {#each botList as b (b.id)}
                                        <option value={b.id}>{b.title || "(제목 없음)"}</option>
                                    {/each}
                                </select>
                            </div>
                            <StatisticsDashboard botId={statBotId} embedded />
                        {/if}
                    </div>
                {:else if activeSection === "collection"}
                    <div class="insight-embed">
                        {#if botList.length === 0 && chatList.length === 0}
                            <div class="console-empty">
                                <div class="console-empty-title">아직 프로젝트가 없어요</div>
                                <div class="console-empty-desc">
                                    미니페이지나 AI 챗을 만들면 수집된 응답·개인정보가 여기 모여요.
                                </div>
                            </div>
                        {:else}
                            <div class="insight-bar">
                                <label class="insight-label" for="coll-pick">프로젝트</label>
                                <select id="coll-pick" class="insight-select" bind:value={collectTarget}>
                                    {#if botList.length}
                                        <optgroup label="미니페이지">
                                            {#each botList as b (b.id)}
                                                <option value={"bot:" + b.id}>{b.title || "(제목 없음)"}</option>
                                            {/each}
                                        </optgroup>
                                    {/if}
                                    {#if chatList.length}
                                        <optgroup label="AI 챗">
                                            {#each chatList as c (c.id)}
                                                <option value={"chat:" + c.id}>{c.title || "(제목 없음)"}</option>
                                            {/each}
                                        </optgroup>
                                    {/if}
                                </select>
                            </div>
                            {#if collectId}
                                <CollectionDashboard
                                    source={collectKind}
                                    botId={collectKind === "bot" ? collectId : null}
                                    chatId={collectKind === "chat" ? collectId : null}
                                    embedded
                                />
                            {/if}
                        {/if}
                    </div>
                {:else if isSearching && visibleList.length === 0}
                    <div class="console-empty">
                        <div class="console-empty-title">
                            검색 결과가 없어요
                        </div>
                        <div class="console-empty-desc">
                            검색어 '{listQuery}'에 해당하는 항목이 없어요. 다른
                            이름으로 찾아보세요.
                        </div>
                    </div>
                {:else}
                    <div class="console-grid">
                        <!-- 새로 만들기 카드 (섹션별 타입 프리셋).
                             검색 중에는 결과만 보이도록 감춘다. -->
                        {#if !isSearching}
                            <button
                                type="button"
                                class="proj-card proj-card-new"
                                on:click={startCreate}
                            >
                                <div class="proj-new-plus">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    >
                                        <line x1="12" x2="12" y1="5" y2="19" />
                                        <line x1="5" x2="19" y1="12" y2="12" />
                                    </svg>
                                </div>
                                <div class="proj-new-title">
                                    {$t("새 {name} 만들기", {
                                        name: $t(currentSection.label),
                                    })}
                                </div>
                                <div class="proj-new-desc">
                                    {activeSection === "chat"
                                        ? "생성형 AI 챗봇을 제작해보세요."
                                        : activeSection === "game"
                                          ? "게임 종류를 고르고 이미지를 바꿔보세요."
                                          : activeSection === "hub"
                                            ? "채팅을 격자로 모아 보여줍니다."
                                            : "빈 페이지 또는 템플릿으로 시작하세요."}
                                </div>
                            </button>
                        {/if}

                        {#if activeSection === "chat"}
                            {#each visibleChats as chat (chat.id)}
                                <div class="proj-card">
                                    <div class="proj-card-top">
                                        {#if getChatProfileImageContent(chat)}
                                            <img
                                                class="proj-avatar"
                                                src={getChatProfileImageContent(
                                                    chat,
                                                )}
                                                alt=""
                                            />
                                        {:else}
                                            <div
                                                class="proj-avatar proj-avatar-blank"
                                            ></div>
                                        {/if}
                                        <span class="proj-badge">AI</span>
                                    </div>
                                    <div class="proj-name">
                                        {chat.title || ""}
                                    </div>
                                    <div class="proj-sub">
                                        {chat.subTitle || ""}
                                    </div>
                                    <button
                                        type="button"
                                        class="proj-edit-btn"
                                        on:click={() =>
                                            navigateTo(
                                                `/chat-builder/${chat.id}`,
                                            )}
                                        >{$t("편집하기")}</button
                                    >
                                </div>
                            {/each}
                        {:else}
                            {#each visibleBots as bot (bot.id)}
                                <div class="proj-card">
                                    <div class="proj-card-top">
                                        {#if bot.iconImageContent}
                                            <img
                                                class="proj-avatar"
                                                src={bot.iconImageContent}
                                                alt=""
                                            />
                                        {:else}
                                            <div
                                                class="proj-avatar proj-avatar-blank"
                                            ></div>
                                        {/if}
                                        <div class="proj-menu">
                                            <button
                                                type="button"
                                                class="proj-menu-btn"
                                                aria-label="메뉴"
                                                on:click|stopPropagation={() =>
                                                    (bot.isMenuPanel =
                                                        !bot.isMenuPanel)}
                                            >
                                                <svg
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <circle
                                                        cx="12"
                                                        cy="5"
                                                        r="1"
                                                    />
                                                    <circle
                                                        cx="12"
                                                        cy="12"
                                                        r="1"
                                                    />
                                                    <circle
                                                        cx="12"
                                                        cy="19"
                                                        r="1"
                                                    />
                                                </svg>
                                            </button>
                                            {#if bot.isMenuPanel}
                                                <div class="proj-menu-panel">
                                                    <button
                                                        type="button"
                                                        on:click={() =>
                                                            initModifyBotProfile(
                                                                bot,
                                                            )}
                                                        >{$_(
                                                            "project.main.7",
                                                        )}<!-- 프로필 수정 --></button
                                                    >
                                                    <button
                                                        type="button"
                                                        class="green"
                                                        on:click={() =>
                                                            clickBotCopy(
                                                                bot.id,
                                                            )}
                                                        >{$_(
                                                            "project.main.8",
                                                        )}<!-- 복제 --></button
                                                    >
                                                    <button
                                                        type="button"
                                                        class="red"
                                                        on:click={() =>
                                                            clickBotDelete(
                                                                bot.id,
                                                            )}
                                                        >{$_(
                                                            "project.main.9",
                                                        )}<!-- 삭제 --></button
                                                    >
                                                </div>
                                            {/if}
                                        </div>
                                    </div>
                                    <div class="proj-name">{bot.title}</div>
                                    <div class="proj-sub">
                                        {bot.subTitle || ""}
                                    </div>
                                    <button
                                        type="button"
                                        class="proj-edit-btn"
                                        on:click={() =>
                                            navigateTo(builderPathOf(bot))}
                                        >{$t("편집하기")}</button
                                    >
                                </div>
                            {/each}
                        {/if}
                    </div>
                {/if}
            </main>
        </div>
    </div>
{/if}

<!-- 프로필 설정(신규) -->
<Dialog
    open={isAddPopup}
    title={$_("project.main.19")}
    on:close={() => (isAddPopup = false)}
>
    <p class="tw-mb-5 tw-text-sm tw-text-muted-foreground">
        {$_("project.main.20")}<!-- 아바톡 목록에서 보여질 프로필을 설정해주세요! -->
    </p>
    <div class="tw-mb-1 tw-flex tw-items-center tw-gap-4">
        {#if botInfo.iconImageContent}
            <img
                class="tw-h-16 tw-w-16 tw-rounded-full tw-object-cover"
                src={botInfo.iconImageContent}
                alt=""
            />
        {:else}
            <div
                class="tw-h-16 tw-w-16 tw-rounded-full tw-border tw-border-dashed tw-border-border tw-bg-muted"
            ></div>
        {/if}
        <Button variant="outline" size="sm" on:click={() => addFileInput.click()}
            >{$_("project.main.21")}<!-- 파일 업로드 --></Button
        >
        <input
            accept="image/png, image/jpeg, image/jpg, image/gif"
            bind:this={addFileInput}
            type="file"
            name="add"
            on:change={(event) => onImageFileSelected(event)}
            hidden
        />
    </div>
    <label class="dlg-label" for="add-name"
        >{$_("project.main.22")}<!-- 프로젝트 이름 --></label
    >
    <input
        id="add-name"
        class="dlg-input"
        type="text"
        bind:value={botInfo.title}
        maxlength="30"
    />
    <label class="dlg-label" for="add-sub"
        >{$_("project.main.24")}<!-- 프로젝트 소개 -->
        <span class="dlg-label-hint">{$_("project.main.25")}</span></label
    >
    <input
        id="add-sub"
        class="dlg-input"
        type="text"
        bind:value={botInfo.subTitle}
        maxlength="30"
    />
    <svelte:fragment slot="footer">
        {#if flagGoBuilder}
            <Button variant="outline" on:click={addBotProfile}
                >{$_("project.main.27")}<!-- 저장 --></Button
            >
            <Button on:click={() => clickGoBuilder()}
                >{$_("project.main.28")}<!-- 제작하기 --></Button
            >
        {:else}
            <Button disabled>{$_("project.main.29")}<!-- 제작중... --></Button>
        {/if}
    </svelte:fragment>
</Dialog>

<!-- 프로필 수정 -->
<Dialog
    open={isModifyPopup}
    title={$_("project.main.7")}
    on:close={() => (isModifyPopup = false)}
>
    <p class="tw-mb-5 tw-text-sm tw-text-muted-foreground">
        {$_("project.main.20")}
    </p>
    <div class="tw-mb-1 tw-flex tw-items-center tw-gap-4">
        {#if modifyBotInfo.iconImageContent}
            <img
                class="tw-h-16 tw-w-16 tw-rounded-full tw-object-cover"
                src={modifyBotInfo.iconImageContent}
                alt=""
            />
        {:else}
            <div
                class="tw-h-16 tw-w-16 tw-rounded-full tw-border tw-border-dashed tw-border-border tw-bg-muted"
            ></div>
        {/if}
        <div class="tw-flex tw-gap-2">
            <Button
                variant="outline"
                size="sm"
                on:click={() => editFileInput.click()}
                >{modifyBotInfo.iconImageContent
                    ? $_("project.main.21_1")
                    : $_("project.main.21")}</Button
            >
            {#if modifyBotInfo.iconImageContent}
                <Button variant="ghost" size="sm" on:click={clickImageDelete}
                    >{$_("project.main.9")}<!-- 삭제 --></Button
                >
            {/if}
        </div>
        <input
            accept="image/png, image/jpeg, image/jpg"
            bind:this={editFileInput}
            type="file"
            name="modify"
            on:change={(event) => onImageFileSelected(event)}
            hidden
        />
    </div>
    <label class="dlg-label" for="mod-name">{$_("project.main.22")}</label>
    <input
        id="mod-name"
        class="dlg-input"
        type="text"
        bind:value={modifyBotInfo.title}
        maxlength="256"
        placeholder={$_("project.main.23")}
    />
    <label class="dlg-label" for="mod-sub"
        >{$_("project.main.24")}
        <span class="dlg-label-hint">{$_("project.main.25")}</span></label
    >
    <input
        id="mod-sub"
        class="dlg-input"
        type="text"
        bind:value={modifyBotInfo.subTitle}
        maxlength="256"
        placeholder={$_("project.main.26")}
    />
    <svelte:fragment slot="footer">
        <Button variant="outline" on:click={modifyBotProfile}
            >{$_("project.main.30")}<!-- 변경하기 --></Button
        >
        <Button on:click={() => clickGoBuilder(true)}
            >{$_("project.main.28")}<!-- 제작하기 --></Button
        >
    </svelte:fragment>
</Dialog>
<!-- 삭제 확인 -->
<Dialog
    open={isDeletePopup}
    title={$_("project.main.31")}
    on:close={() => (isDeletePopup = false)}
>
    <p class="tw-text-sm tw-text-muted-foreground">
        {$_("project.main.32")}<br />{$_("project.main.33")}
    </p>
    <svelte:fragment slot="footer">
        <Button variant="outline" on:click={() => (isDeletePopup = false)}
            >{$_("project.main.33_1")}<!-- 닫기 --></Button
        >
        <Button variant="destructive" on:click={actionBotDelete}
            >{$_("project.main.33_2")}<!-- 삭제하기 --></Button
        >
    </svelte:fragment>
</Dialog>

<!-- 생성 제한 안내 -->
<Dialog
    open={limitNoticePopup}
    title="플랜 안내"
    on:close={() => (limitNoticePopup = false)}
>
    <p class="tw-text-sm tw-text-foreground">
        {$_("project.main.34")}
        {$_("project.main.35")}<span class="tw-font-bold tw-text-primary"
            >{$_("project.main.36")}{availableCreateCnt}{$_(
                "project.main.37",
            )}</span
        >{$_("project.main.38")}
    </p>
    <svelte:fragment slot="footer">
        <Button variant="outline" on:click={() => (limitNoticePopup = false)}
            >{$_("project.main.40")}<!-- 확인 --></Button
        >
        <Button on:click={clickChangePlan}
            >{$_("project.main.39")}<!-- 플랜변경 --></Button
        >
    </svelte:fragment>
</Dialog>
<div class="image-loading-popup2" class:show={imageLoadingPopupFlag}>
    <div class="popup-layer loading">
        <div class="bring-image">
            <div class="spinner"></div>
            <div>{$_("project.main.46")}<!-- 아바톡을 복제하고 있어요! --></div>
        </div>
    </div>
</div>

<style>
    strong {
        font-size: 15px;
    }

    @keyframes spinner {
        to {
            transform: rotate(360deg);
        }
    }

    .spinner:before {
        position: absolute;
        left: 53px;
        content: "";
        box-sizing: border-box;
        position: absolute;
        top: 40%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        border-radius: 50%;
        border-top: 2px solid #f7528a;
        border-right: 2px solid transparent;
        animation: spinner 0.7s linear infinite;
    }

    .cursor {
        cursor: pointer;
    }

    .avatar-img {
        margin-right: 14px;
        width: 60px;
        height: 60px;
        margin-bottom: 5px;
        border-radius: 100px;
    }

    .frofile-button.waiting {
        background-color: #808697;
    }

    /* 카드 공통 크기 고정 */
    .avatalk-version-choice .blank-page-avatalk._2,
    .avatalk-version-choice .template-page-avatalk._2 {
        width: 320px;
        min-height: 320px;
        display: flex;
        flex-direction: column;
    }

    /* isChoiceTypePage 이미지 */
    .avatalk-version-choice:not(.select-page) .image-165 {
        width: 100%;
        height: 180px;
        object-fit: contain;
        margin-top: 10px;
        padding: 0;
        flex-shrink: 0;
    }

    /* isChoiceTypePage 텍스트 영역 */
    .avatalk-version-choice:not(.select-page) .text-block-97-2 {
        flex: 1;
    }

    /* isSelectPage 이미지 - 상단 꽉 채움 */
    .avatalk-version-choice.select-page .image-165 {
        width: 100%;
        height: 200px;
        object-fit: cover;
        padding: 0;
        border-radius: 10px 10px 0 0;
        display: block;
        flex-shrink: 0;
    }

    /* isSelectPage 카드 wrapper - padding-top 제거, overflow hidden으로 radius 클리핑 */
    .avatalk-version-choice.select-page .blank-page-avatalk._2,
    .avatalk-version-choice.select-page .template-page-avatalk._2 {
        padding-top: 0;
        overflow: hidden;
        border-radius: 20px;
    }

    /* isSelectPage 텍스트 영역 */
    .avatalk-version-choice.select-page .text-block-96-2 {
        padding: 14px 16px 6px;
    }

    .avatalk-version-choice.select-page .text-block-97-2 {
        padding: 0 16px 20px;
        flex: 1;
    }

    .container.home {
        align-items: center;
        height: 100%;
        /* 콘솔이 max-width로 가운데 정렬되므로 좌우 여백을 동일 토큰 배경으로 채워 이음새 제거 */
        background: hsl(var(--sb-background));
    }

    .version-choice-copy {
        align-items: center;
    }

    .version-choice-copy .div-block-77 {
        align-self: stretch;
    }

    .avatalk-version-choice {
        display: none;
        position: relative;
        width: 100%;
        flex: 1;
        margin-top: 0;
        margin-bottom: 0;
        justify-content: center;
        align-items: center;
    }

    .template-select-page {
        justify-content: flex-start;
        align-items: center;
        padding: 48px 0;
    }

    .template-content-wrapper {
        display: flex;
        flex-direction: column;
    }

    .template-type-tabs {
        display: flex;
        gap: 10px;
        margin-bottom: 28px;
        border-bottom: none;
        width: auto;
    }

    .template-tab-item {
        padding: 10px 32px;
        font-family: "Noto sans kr 500", sans-serif;
        font-size: 15px;
        color: #aaa;
        border-radius: 10px;
        border: 1.5px solid #e0e0e0;
        background-color: #fff;
        transition: all 0.2s;
        white-space: nowrap;
    }

    .template-tab-item.active {
        color: #fff;
        background-color: #6372ff;
        border-color: #6858ed;
        font-weight: 700;
    }

    .template-cards-wrapper {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        width: calc(310px * 4 + 20px * 3);
    }

    .template-preview-overlay {
        flex-direction: column;
        gap: 10px;
    }

    .overlay-btn {
        padding: 8px 20px;
        border-radius: 6px;
        border: 1.5px solid #6372ff54;
        background: #6372ff;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        font-family: "Noto sans kr", sans-serif;
        transition: background 0.15s;
        min-width: 200px;
        min-height: 50px;
        border-radius: 10px;
    }

    .overlay-btn:hover {
        background: rgba(255, 255, 255, 0.2);
    }

    .overlay-btn-use:hover {
        background: rgba(255, 255, 255, 0.35);
    }

    .template-card-item {
        width: 310px;
        border-radius: 16px;
        overflow: hidden;
        border: 1.5px solid #e4eafb;
        background: #fff;
        transition: all 0.2s;
        cursor: pointer;
    }

    .template-card-item:hover {
        border-color: #6858ed;
        transform: translateY(-4px);
        box-shadow: 0 8px 20px rgba(104, 88, 237, 0.18);
    }

    .template-thumb-area {
        position: relative;
        overflow: hidden;
    }

    .template-thumb {
        width: 100%;
        height: 540px;
        display: block;
        border: none;
        pointer-events: none;
    }

    .template-card-item:hover {
        transform: translateY(-4px);
    }

    .template-preview-overlay {
        position: absolute;
        inset: 0;
        background: rgba(104, 88, 237, 0.55);
        color: #fff;
        font-family: "Noto sans kr 700", sans-serif;
        font-size: 16px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.2s;
    }

    .template-card-item:hover .template-preview-overlay {
        opacity: 1;
    }

    .template-card-title {
        padding: 12px 14px;
        font-size: 14px;
        font-family: "Noto sans kr 500", sans-serif;
        color: #333;
    }

    /* Preview page */
    .preview-page {
        flex-direction: column;
    }

    .preview-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 24px;
        flex: 1;
        width: 100%;
        padding-top: 40px;
    }

    .preview-iframe {
        width: 390px;
        flex: 1;
        max-height: 720px;
        border: none;
        border-radius: 20px;
        box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
    }

    .preview-placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
    }

    .preview-placeholder-img {
        width: 390px;
        border-radius: 20px;
        box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
        object-fit: cover;
    }

    .use-template-btn {
        padding: 14px 72px;
        background-color: #6858ed;
        color: #fff;
        border: none;
        border-radius: 50px;
        font-family: "Noto sans kr 700", sans-serif;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s;
        flex-shrink: 0;
    }

    .use-template-btn:hover {
        background-color: #5547d0;
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(104, 88, 237, 0.4);
    }

    /* New profile page (fullscreen) */
    .new-profile-page {
        justify-content: center;
        align-items: center;
    }

    .new-profile-card {
        background: #fff;
        border-radius: 24px;
        padding: 40px 48px;
        width: 480px;
        box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1);
        position: relative;
    }
    .new-profile-btn-row {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        margin-top: 8px;
    }

    .new-profile-btn-row .save-button,
    .new-profile-btn-row .frofile-button {
        flex: 1;
        margin: 0;
        text-align: center;
    }

    /* 게임 타입 선택 카드 — 일러스트 자리에 인라인 SVG를 넣는다(게임용 이미지 자산이 아직 없다).
       크기는 select-page의 .image-165(200px)와 맞춰 다른 오버레이와 리듬을 같게 한다. */
    .game-type-art {
        width: 100%;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px 20px 0 0;
        flex-shrink: 0;
        background: #0d1430;
    }

    .game-type-art svg {
        width: 132px;
        height: 132px;
    }

    .game-type-card.is-soon {
        cursor: default;
        opacity: 0.55;
    }

    .game-type-soon {
        margin-left: 8px;
        padding: 2px 10px;
        border: 1px solid #d0d5e2;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 500;
        color: #8a90a2;
        vertical-align: middle;
    }

    /* ===== 콘솔 셸(좌측 사이드바 + 우측 콘텐츠) — shadcn(--sb-*) 토큰 룩 ===== */
    .console-shell {
        display: flex;
        width: 100%;
        /* 앱 공용 가로 상한 토큰(빌더/헤더와 공유). 값은 tailwind.css :root --app-max-w 한 곳에서 조절. */
        max-width: var(--app-max-w, 1920px);
        margin: 0 auto;
        flex: 1;
        min-height: 0;
        background: hsl(var(--sb-background));
        font-family: "Noto Sans KR", sans-serif;
    }

    .console-sidebar {
        display: flex;
        flex-direction: column;
        width: 240px;
        flex-shrink: 0;
        box-sizing: border-box;
        border-right: 1px solid hsl(var(--sb-border));
        background: hsl(var(--sb-sidebar));
        padding: 22px 12px;
        overflow-y: auto;
    }

    .console-sidebar-title {
        padding: 0 12px 10px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: hsl(var(--sb-muted-foreground));
    }

    .console-nav {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .console-nav-btn {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 10px 12px;
        border: none;
        border-radius: 10px;
        background: transparent;
        color: hsl(var(--sb-foreground) / 0.72);
        font-size: 14px;
        text-align: left;
        cursor: pointer;
        transition:
            background 0.15s,
            color 0.15s;
    }

    .console-nav-btn:hover {
        background: hsl(var(--sb-muted));
        color: hsl(var(--sb-foreground));
    }

    .console-nav-btn.is-active {
        background: hsl(var(--sb-primary) / 0.1);
        color: hsl(var(--sb-primary));
        font-weight: 700;
    }

    .console-nav-icon {
        width: 18px;
        height: 18px;
        flex-shrink: 0;
    }

    .console-nav-label {
        flex: 1;
    }

    .console-nav-count {
        min-width: 20px;
        padding: 1px 8px;
        border-radius: 999px;
        background: hsl(var(--sb-muted));
        color: hsl(var(--sb-muted-foreground));
        font-size: 12px;
        font-weight: 600;
        text-align: center;
    }

    .console-nav-btn.is-active .console-nav-count {
        background: hsl(var(--sb-primary) / 0.15);
        color: hsl(var(--sb-primary));
    }

    .console-nav-soon {
        padding: 1px 8px;
        border: 1px solid hsl(var(--sb-border));
        border-radius: 999px;
        font-size: 11px;
        color: hsl(var(--sb-muted-foreground));
    }

    .console-main {
        flex: 1;
        min-width: 0;
        box-sizing: border-box;
        overflow-y: auto;
        padding: 32px 40px 56px;
    }

    .console-head {
        margin-bottom: 24px;
    }

    .console-title {
        font-size: 24px;
        font-weight: 800;
        color: hsl(var(--sb-foreground));
    }

    .console-desc {
        margin-top: 6px;
        font-size: 14px;
        color: hsl(var(--sb-muted-foreground));
    }

    /* ----- 목록 검색/정렬 툴바 ----- */
    .list-toolbar {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
        flex-wrap: wrap;
    }

    .list-search {
        position: relative;
        display: flex;
        align-items: center;
        flex: 1 1 260px;
        max-width: 360px;
    }

    .list-search-icon {
        position: absolute;
        left: 12px;
        width: 16px;
        height: 16px;
        pointer-events: none;
        color: hsl(var(--sb-muted-foreground));
    }

    .list-search-input {
        width: 100%;
        box-sizing: border-box;
        height: 38px;
        padding: 0 34px 0 36px;
        border: 1px solid hsl(var(--sb-input));
        border-radius: 8px;
        background: hsl(var(--sb-card));
        color: hsl(var(--sb-foreground));
        font-size: 14px;
        font-family: inherit;
    }

    .list-search-input::placeholder {
        color: hsl(var(--sb-muted-foreground));
    }

    .list-search-input:focus {
        outline: none;
        border-color: hsl(var(--sb-ring));
        box-shadow: 0 0 0 2px hsl(var(--sb-ring) / 0.3);
    }

    .list-search-clear {
        position: absolute;
        right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: hsl(var(--sb-muted));
        color: hsl(var(--sb-muted-foreground));
        font-size: 14px;
        line-height: 1;
        cursor: pointer;
    }

    .list-search-clear:hover {
        color: hsl(var(--sb-foreground));
    }

    /* 통계/수집 선택기와 같은 룩을 쓰되 폭만 좁힌다. */
    .list-sort {
        min-width: 140px;
    }

    .list-count {
        margin-left: auto;
        font-size: 13px;
        color: hsl(var(--sb-muted-foreground));
    }

    .console-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
        gap: 20px;
    }

    /* ----- 프로젝트 카드 (shadcn 카드 룩) ----- */
    .proj-card {
        position: relative;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        min-height: 200px;
        padding: 20px;
        border: 1px solid hsl(var(--sb-border));
        border-radius: 16px;
        background: hsl(var(--sb-card));
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
        transition:
            border-color 0.18s,
            box-shadow 0.18s,
            transform 0.18s;
    }

    .proj-card:hover {
        border-color: hsl(var(--sb-primary) / 0.5);
        box-shadow: 0 8px 24px rgba(99, 114, 255, 0.14);
        transform: translateY(-2px);
    }

    .proj-card-top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 14px;
    }

    .proj-avatar {
        width: 56px;
        height: 56px;
        border-radius: 16px;
        object-fit: cover;
        background: hsl(var(--sb-muted));
    }

    .proj-avatar-blank {
        border: 1px dashed hsl(var(--sb-border));
    }

    .proj-badge {
        padding: 3px 10px;
        border-radius: 999px;
        background: hsl(var(--sb-primary) / 0.1);
        color: hsl(var(--sb-primary));
        font-size: 11px;
        font-weight: 700;
    }

    .proj-name {
        font-size: 16px;
        font-weight: 700;
        color: hsl(var(--sb-foreground));
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .proj-sub {
        flex: 1;
        margin-top: 4px;
        min-height: 34px;
        font-size: 13px;
        color: hsl(var(--sb-muted-foreground));
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .proj-edit-btn {
        margin-top: 14px;
        width: 100%;
        height: 40px;
        border: none;
        border-radius: 10px;
        background: hsl(var(--sb-primary));
        color: hsl(var(--sb-primary-foreground));
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        transition: opacity 0.15s;
    }

    .proj-edit-btn:hover {
        opacity: 0.9;
    }

    /* 카드 메뉴(수정/복제/삭제) */
    .proj-menu {
        position: relative;
    }

    .proj-menu-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 8px;
        background: transparent;
        color: hsl(var(--sb-muted-foreground));
        cursor: pointer;
    }

    .proj-menu-btn:hover {
        background: hsl(var(--sb-muted));
    }

    .proj-menu-btn svg {
        width: 18px;
        height: 18px;
    }

    .proj-menu-panel {
        position: absolute;
        top: 36px;
        right: 0;
        z-index: 5;
        display: flex;
        flex-direction: column;
        min-width: 132px;
        padding: 6px;
        border: 1px solid hsl(var(--sb-border));
        border-radius: 12px;
        background: hsl(var(--sb-card));
        box-shadow: 0 8px 24px rgba(16, 24, 40, 0.14);
    }

    .proj-menu-panel button {
        padding: 9px 12px;
        border: none;
        border-radius: 8px;
        background: transparent;
        color: hsl(var(--sb-foreground));
        font-size: 13px;
        text-align: left;
        cursor: pointer;
    }

    .proj-menu-panel button:hover {
        background: hsl(var(--sb-muted));
    }

    .proj-menu-panel button.green {
        color: #0ea371;
    }

    .proj-menu-panel button.red {
        color: hsl(var(--sb-destructive));
    }

    /* 새로 만들기 카드 */
    .proj-card-new {
        align-items: center;
        justify-content: center;
        text-align: center;
        border: 1.5px dashed hsl(var(--sb-border));
        background: hsl(var(--sb-muted) / 0.35);
        cursor: pointer;
    }

    .proj-card-new:hover {
        border-color: hsl(var(--sb-primary));
        background: hsl(var(--sb-primary) / 0.05);
        transform: translateY(-2px);
    }

    .proj-new-plus {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        margin-bottom: 12px;
        border-radius: 14px;
        background: hsl(var(--sb-primary) / 0.12);
        color: hsl(var(--sb-primary));
    }

    .proj-new-plus svg {
        width: 24px;
        height: 24px;
    }

    .proj-new-title {
        font-size: 15px;
        font-weight: 700;
        color: hsl(var(--sb-foreground));
    }

    .proj-new-desc {
        margin-top: 4px;
        font-size: 12px;
        color: hsl(var(--sb-muted-foreground));
    }

    /* 준비중(게임) 빈 상태 */
    .console-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 80px 20px;
        text-align: center;
        color: hsl(var(--sb-muted-foreground));
    }

    .console-empty-icon {
        width: 56px;
        height: 56px;
        opacity: 0.6;
    }

    .console-empty-title {
        font-size: 18px;
        font-weight: 700;
        color: hsl(var(--sb-foreground));
    }

    .console-empty-desc {
        font-size: 14px;
    }

    .asset-embed {
        width: 100%;
    }

    /* 통계/수집 섹션: 프로젝트 선택기 + 대시보드 임베드 */
    .insight-embed {
        width: 100%;
    }
    .insight-bar {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 12px;
    }
    .insight-label {
        font-size: 12px;
        font-weight: 600;
        color: hsl(var(--sb-muted-foreground));
    }
    .insight-select {
        min-width: 220px;
        max-width: 360px;
        height: 38px;
        padding: 0 12px;
        border: 1px solid hsl(var(--sb-input));
        border-radius: 8px;
        background: hsl(var(--sb-card));
        color: hsl(var(--sb-foreground));
        font-size: 14px;
        font-family: inherit;
        cursor: pointer;
    }
    .insight-select:focus {
        outline: none;
        border-color: hsl(var(--sb-ring));
        box-shadow: 0 0 0 2px hsl(var(--sb-ring) / 0.3);
    }

    /* 다이얼로그(프로필 설정/수정 등) 폼 필드 */
    .dlg-label {
        display: block;
        margin: 16px 0 6px;
        font-size: 13px;
        font-weight: 500;
        color: hsl(var(--sb-foreground));
    }

    .dlg-label-hint {
        margin-left: 4px;
        font-size: 12px;
        font-weight: 400;
        color: hsl(var(--sb-muted-foreground));
    }

    .dlg-input {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        padding: 0 12px;
        border: 1px solid hsl(var(--sb-input));
        border-radius: 8px;
        background: hsl(var(--sb-background));
        color: hsl(var(--sb-foreground));
        font-size: 14px;
    }

    .dlg-input:focus {
        outline: none;
        border-color: hsl(var(--sb-ring));
        box-shadow: 0 0 0 2px hsl(var(--sb-ring) / 0.3);
    }

    @media screen and (max-width: 767px) {
        .console-shell {
            flex-direction: column;
        }
        .console-sidebar {
            width: 100%;
            border-right: none;
            border-bottom: 1px solid hsl(var(--sb-border));
            padding: 12px;
        }
        .console-nav {
            flex-direction: row;
            flex-wrap: wrap;
        }
        .console-nav-btn {
            width: auto;
        }
        .console-main {
            padding: 20px 16px 40px;
        }
    }
</style>
